/**
 * @generated SignedSource<<853e346f439234f193a90beb9db89fdf>>
 * @relayHash 0681956309889e6b5cf5f017cd1eccbd
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0681956309889e6b5cf5f017cd1eccbd

import { ConcreteRequest } from 'relay-runtime';
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type De_simulateBetterDocResearchInput = {
  sessionId: number;
};
export type useSimulateBetterDocResearchMutation$variables = {
  input: De_simulateBetterDocResearchInput;
};
export type useSimulateBetterDocResearchMutation$data = {
  readonly de_simulateBetterDocResearch: {
    readonly actionResult: {
      readonly betterDocState: de_BetterDocRecommendationState | null;
      readonly caseId: string | null;
      readonly errorReason: string | null;
      readonly exchangeId: number | null;
      readonly httpStatusCode: number | null;
      readonly isSuccessful: boolean;
      readonly sessionId: number;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useSimulateBetterDocResearchMutation = {
  response: useSimulateBetterDocResearchMutation$data;
  variables: useSimulateBetterDocResearchMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": "actionResult",
  "args": null,
  "concreteType": "de_BetterDocSessionActionResult",
  "kind": "LinkedField",
  "name": "de_BetterDocSessionActionResult",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuccessful",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "httpStatusCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "betterDocState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exchangeId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSimulateBetterDocResearchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_simulateBetterDocResearchPayload",
        "kind": "LinkedField",
        "name": "de_simulateBetterDocResearch",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSimulateBetterDocResearchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_simulateBetterDocResearchPayload",
        "kind": "LinkedField",
        "name": "de_simulateBetterDocResearch",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0681956309889e6b5cf5f017cd1eccbd",
    "metadata": {},
    "name": "useSimulateBetterDocResearchMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4c2529afc0656a6b5b7f04ad90fb925f";

export default node;
